/** Timing — how long each game phase lasts */
export const BET_PHASE_MS = 5_000;
export const POST_CRASH_DELAY_MS = 3_000;
export const LAUNCH_PHASE_MS = 1_000;

/** Multiplier growth — exponential curve parameter */
export const GROWTH_RATE = 0.0693;

/** Crash-point generation */
export const MIN_CRASH_POINT = 1.0;
export const CRASH_HOUSE_EDGE = 0.97;

/** Betting limits */
export const MIN_CASHOUT_MULTIPLIER = 1.01;
export const MIN_BET_AMOUNT = 0.01;
export const MAX_BET_AMOUNT = 1_000_000;
export const BET_STEP = 0.01;
export const INITIAL_BALANCE = 10_000;
export const DEFAULT_BET_AMOUNTS = [1.0, 5.0] as const;
export const DEFAULT_AUTO_CASHOUT = 2.0;
export const BET_STEP_SMALL = 0.10;
export const BET_STEP_LARGE = 1.00;

/** Auto-cashout preset multipliers */
export const AUTO_CASHOUT_PRESETS = [1.5, 2, 3, 5, 10, 25] as const;

/** Round history */
export const MAX_HISTORY = 20;
export const MAX_HISTORY_COMPACT = 25;
export const MAX_HISTORY_FULL = 120;
export const MAX_BET_HISTORY = 50;

/** Milestone thresholds for announcements */
export const MILESTONES = [2, 5, 10, 25, 50, 100] as const;

/** Bet amount quick-pick presets */
export const BET_PRESETS = [1, 5, 10, 25, 50, 100] as const;

/** localStorage / cookie key names */
export const STORAGE_KEY_BALANCE = 'memePumpBalance';
export const STORAGE_KEY_PROFILE = 'memePumpProfile';
export const STORAGE_KEY_AUDIO_PREFS = 'memePumpAudioPrefs';

/** Identity defaults */
export const DEFAULT_USERNAME = 'Player';
export const DEFAULT_AVATAR = 'monkey';
export const DEFAULT_CURRENCY = 'DOGE';
export const MAX_USERNAME_LENGTH = 20;

/** Path helper for avatar images */
export const avatarSrc = (key: string) =>
  `assets/avatars/${key}.png`;

/** Multiplier display — visual scale curve */
export const MULT_SCALE_GROWTH = 0.25;
export const MULT_SCALE_MAX = 1.5;

/** Multiplier lerp — smooth interpolation */
export const LERP_BASE = 0.15;
export const LERP_DIFF_FACTOR = 0.1;
export const LERP_MAX = 0.35;
export const LERP_SNAP_THRESHOLD = 0.001;

/** Shared scale function for multiplier display */
export function computeMultiplierScale(mult: number): number {
  if (!isFinite(mult) || mult <= 1) return 1;
  const growth = Math.log10(mult) * MULT_SCALE_GROWTH;
  return Math.min(MULT_SCALE_MAX, 1 + growth);
}

/** UI layout */
export const MOBILE_BREAKPOINT = 768;
export const FALLBACK_HEADER_HEIGHT = 56;

/** Startup overlay */
export const STARTUP_PROGRESS_BAR_SECONDS = 7;

/** Audio — paths & keys */
export const AUDIO_BASE_PATH = 'assets/audio';
export const BG_MUSIC_FILENAME = 'meme-pump-theme.mp3';
export const BG_MUSIC_KEY = 'bg-music';

/** Audio — fade timing */
export const AUDIO_FADE_OUT_MS = 600;
export const AUDIO_FADE_IN_MS = 800;
export const BG_FADE_IN_MS = 1200;

/** Audio — priority levels */
export const PRIORITY_BG = 0;
export const PRIORITY_UI = 1;
export const PRIORITY_ACTION = 2;
export const PRIORITY_OUTCOME = 3;

/** Audio — suppression block durations */
export const BLOCK_MS_CASHOUT = 800;
export const BLOCK_MS_LOSS = 700;
export const BLOCK_MS_CRASH = 600;
export const BLOCK_MS_LAUNCH = 500;
export const BLOCK_MS_UI = 250;
export const BLOCK_MS_DEFAULT = 500;
